import { Component, Input, OnInit, ViewChild, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ActivatedRoute, Router, ActivationStart, ActivatedRouteSnapshot, RouterLinkActive, RouterLink, RouterOutlet } from "@angular/router";

import { ApiService } from "src/app/api.service";
import { DvsUtilities } from "src/app/dvs-utilities";
import { ItemHealth } from "src/app/item-health";
import { IsNotGhostPipe } from "src/app/pipes";
import { AssemblyConfig, APIResults } from "src/app/sharedinterfaces";
declare const BrandVars;

@Component({
	selector: "app-mech-diag",
	templateUrl: "./mech-diag.component.html",
	styleUrls: ["./mech-diag.component.scss"],
	imports: [RouterLinkActive, RouterLink, RouterOutlet, IsNotGhostPipe]
})
export class MechDiagComponent implements OnInit {
	private router = inject(Router);
	private route = inject(ActivatedRoute);

	public api = inject(ApiService);

	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	fleet: APIResults.Fleet;
	@Input()
	components: APIResults.AssetComponentList;

	@ViewChild("routerContent") routerContent: any;

	selectedcomponent: AssemblyConfig.Component;
	selectedshaft?: AssemblyConfig.Shaft;
	selectedmaintenance: string;
	public brand = BrandVars;
	public ItemHealth = ItemHealth;

	constructor() {
		// Watch for route param changes
		this.router.events.pipe(takeUntilDestroyed()).subscribe(evt => {
			if (evt instanceof ActivationStart) {
				const snapshot = evt.snapshot;
				// Multiple ActivationStarts fire for a route change
				// Only react when the activation is for a direct child of this route
				if (snapshot.parent && snapshot.parent.routeConfig === this.route.snapshot.routeConfig) {
					this.updateSelectedComponentFromRoute(snapshot);
				}
			}
		});
	}

	ngOnInit(): void {
		// Initialize selected component from route
		this.updateSelectedComponentFromRoute(this.route.snapshot.firstChild);
	}

	public getComponentRouterLink(componentId: any) {
		const url = this.router.url || "";
		const m = url.match(new RegExp('/md/[^/]+(/.*)?$'));
		const tail = m && m[1] ? m[1] : "";
		const tailSegments = tail ? tail.split("/").filter(s => s.length > 0) : [];
		return [componentId, ...tailSegments];
	}

	// This runs before updateRouterOutlet so that the new selection is available to the outlet component
	private updateSelectedComponentFromRoute(snapshot: ActivatedRouteSnapshot) {
		this.selectedcomponent = undefined;
		this.selectedshaft = undefined;
		this.selectedmaintenance = undefined;

		if (snapshot?.params && snapshot.params["componentid"]) {
			const result = DvsUtilities.FindComponentAndShaftById(this.components, snapshot.params["componentid"]);
			if (result) {
				this.selectedcomponent = result.component;
				this.selectedshaft = result.shaft;
			} else {
				// Bad component id
				this.router.navigate(["../"], { relativeTo: this.route });
			}
		} else {
			const routePath = snapshot.url.length > 0 ? snapshot.url[0].path : undefined;
			// If there's a routePath, we're looking at a maintenance item. If not it will be blank (component root).
			this.selectedmaintenance = routePath;
		}
	}

	lookupLRU(component: AssemblyConfig.Component): string {
		if (component.lru) {
			const lru = this.components.lru.find(item => item.id === component.lru);
			if (lru) {
				return lru.name;
			}
		}
		return "";
	}

	private activeRouteComponent: any;
	public updateRouterOutlet(routecomponent?: any) {
		if (routecomponent) {
			this.activeRouteComponent = routecomponent;
		}
		if (this.activeRouteComponent) {
			this.activeRouteComponent.asset = this.asset;
			this.activeRouteComponent.fleet = this.fleet;
			this.activeRouteComponent.components = this.components;
			this.activeRouteComponent.component = this.selectedcomponent;
			this.activeRouteComponent.shaft = this.selectedshaft;
		}
		this.scrollToSection();
	}

	private scrollToSection() {
		const element = this.routerContent?.nativeElement;
		if (element) {
			element.scrollIntoView({ behavior: "smooth", block: "start" });
		}
	}
}
